import { action } from 'satcheljs';

export const onUserSelfDeleted = action('onUserSelfDeleted');
